// extracted by mini-css-extract-plugin
module.exports = {"veryRisk_container":"file_details_tabbar_veryRisk_container__1D_gc","tabbar_icon":"file_details_tabbar_tabbar_icon__3BGQk"};